// **************************
// *** CardFotoPerfil | fotoperfil.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 10/07/24 / IA
// *** 12/10/24 | 12h25 IA | modificado para aceitar foto de colaborador que está sendo criado
// **************************






import { useState , useEffect} from 'react';
import Swal from 'sweetalert2';
import apiaxios from '../../../../Services/apiaxios';
import { decrypt } from '../../../../Services/cryptoUtils'
import { AutoLogout } from '../../../../Services/autologout';

const CardFotoPerfil = ({ userId }) => {
    // const tokenASW = localStorage.getItem("tokenasw"); // modificado pela linha abaixo 27/10/25w
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const [selectedFile, setSelectedFile] = useState(null);
    const [visibleButtons, setVisibleButtons] = useState(true);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result.split(',')[1]; // Remove o prefixo 'data:image/jpeg;base64,'
                setSelectedFile(base64Image);
                Swal.fire({
                    title: 'Confirmação',
                    text: 'Confirma esta foto/imagem?',
                    imageUrl: reader.result,
                    showCancelButton: true,
                    confirmButtonText: 'Sim, confirmo!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleUploadPhoto(base64Image);
                    }
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUploadPhoto = async (base64Photo) => {
        try {
            const response = await apiaxios.put('/usuario/TrocarFotoWeb', {
                id_usuario: userId, // Use o ID do usuário passado como prop
                foto: base64Photo
            },
            {
                params: {
                    id_usuario: userId,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Sucesso', 'Foto salva com sucesso!', 'success');
            } else {
                Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
        }
        setVisibleButtons(false);
    };

    return (
        visibleButtons === true && (
            <div>
                <br />
                <input
                    type="file"
                    accept="image/*"
                    capture="user"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="cameraInput"
                />
                <button className="btn btn-secondary btn-sm" onClick={() => document.getElementById('cameraInput').click()}>Câmera</button>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="galleryInput"
                />
                <button className="btn btn-secondary btn-sm ml-10" onClick={() => document.getElementById('galleryInput').click()}>Galeria</button>
                </div>
            )
    );
};

export default CardFotoPerfil;
